export type SymbolType = 'red-x' | 'red-dash' | 'red-diagonal' | ''

export enum Form781AStatus {
  InProgress = 'in-progress',
  Completed = 'completed',
}

export interface DiscrepancyData {
  id: string
  sym: SymbolType
  jcn: string
  dateDisc: string
  docNo: string
  cf: boolean
  xf: boolean
  dateCorrected: string
  wucRef: string
  faultCode: string
  staCode: string
  discrepancyText: string
  correctiveAction: string
  discoveredBy: string
  discoveredByEmployeeNo: string
  correctedBy: string
  correctedByEmployeeNo: string
  inspectedByEmployeeNo: string
}

export interface FormEntry {
  id: string
  annotationId: string | null
  annotationLabel: string | null
  inspectionAreaId: string | null
  sym: SymbolType
  jcn: string
  dateDisc: string
  docNo: string
  cf: boolean
  xf: boolean
  dateCorrected: string
  wucRef: string
  faultCode: string
  staCode: string
  discrepancyText: string
  correctiveAction: string
  discoveredBy: string
  discoveredByEmployeeNo: string
  correctedBy: string
  correctedByEmployeeNo: string
  inspectedByEmployeeNo: string
}

export interface Form781AData {
  name: string
  status: Form781AStatus
  createdAt: string
  header: {
    from: string
    to: string
    mds: string
    serialNumber: string
  }
  entries: FormEntry[]
  discrepancies?: DiscrepancyData[]
}

export const createDefaultDiscrepancy = (): DiscrepancyData => ({
  id: crypto.randomUUID(),
  sym: '',
  jcn: '',
  dateDisc: new Date().toISOString().split('T')[0],
  docNo: '',
  cf: false,
  xf: false,
  dateCorrected: '',
  wucRef: '',
  faultCode: '',
  staCode: '',
  discrepancyText: '',
  correctiveAction: '',
  discoveredBy: '',
  discoveredByEmployeeNo: '',
  correctedBy: '',
  correctedByEmployeeNo: '',
  inspectedByEmployeeNo: '',
})

export const createDefaultEntry = (
  annotationId: string | null = null,
  annotationLabel: string | null = null,
  inspectionAreaId: string | null = null
): FormEntry => ({
  id: crypto.randomUUID(),
  annotationId,
  annotationLabel,
  inspectionAreaId,
  sym: '',
  jcn: '',
  dateDisc: new Date().toISOString().split('T')[0],
  docNo: '',
  cf: false,
  xf: false,
  dateCorrected: '',
  wucRef: '',
  faultCode: '',
  staCode: '',
  discrepancyText: '',
  correctiveAction: '',
  discoveredBy: '',
  discoveredByEmployeeNo: '',
  correctedBy: '',
  correctedByEmployeeNo: '',
  inspectedByEmployeeNo: '',
})

const generateDefaultFormName = (): string => {
  const now = new Date()
  return `Form - ${now.toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric' })}`
}

export const createDefaultFormData = (name?: string): Form781AData => ({
  name: name ?? generateDefaultFormName(),
  status: Form781AStatus.InProgress,
  createdAt: new Date().toISOString(),
  header: {
    from: '',
    to: '',
    mds: '',
    serialNumber: '',
  },
  entries: [],
})
